(() => {

  /* =======================================================
     SYNMAC MENU ICON LIBRARY
     Icon automatically chosen from menu title
     ======================================================= */

  const icons = {

    home: `
      <svg viewBox="0 0 24 24">
        <path d="M3 11.5 12 4l9 7.5"/>
        <path d="M5 10.5V21h14V10.5"/>
        <path d="M9 21v-6h6v6"/>
      </svg>
    `,

    shop: `
      <svg viewBox="0 0 24 24">
        <path d="M6 8h12l1 13H5L6 8Z"/>
        <path d="M9 9V6a3 3 0 0 1 6 0v3"/>
      </svg>
    `,

    offer: `
      <svg viewBox="0 0 24 24">
        <path d="M4 7h7l9 9-4 4-9-9V4Z"/>
        <circle cx="8" cy="8" r="1"/>
      </svg>
    `,

    info: `
      <svg viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="9"/>
        <path d="M12 11v6"/>
        <path d="M12 7h.01"/>
      </svg>
    `,

    contact: `
      <svg viewBox="0 0 24 24">
        <path d="M5 4h4l2 5-3 2a14 14 0 0 0 5 5l2-3 5 2v4c0 1-1 2-2 2C10 21 3 14 3 6c0-1 1-2 2-2Z"/>
      </svg>
    `,

    shield: `
      <svg viewBox="0 0 24 24">
        <path d="M12 3 20 6v5c0 5-3.4 8.5-8 10-4.6-1.5-8-5-8-10V6l8-3Z"/>
        <path d="m9 12 2 2 4-4"/>
      </svg>
    `,

    globe: `
      <svg viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="9"/>
        <path d="M3 12h18"/>
        <path d="M12 3a15 15 0 0 1 0 18"/>
        <path d="M12 3a15 15 0 0 0 0 18"/>
      </svg>
    `,

    blog: `
      <svg viewBox="0 0 24 24">
        <path d="M5 4h11a3 3 0 0 1 3 3v13H8a3 3 0 0 1-3-3V4Z"/>
        <path d="M8 8h7"/>
        <path d="M8 12h7"/>
      </svg>
    `,

    heart: `
      <svg viewBox="0 0 24 24">
        <path d="M20.8 5.8c-2-2-5.2-2-7.2 0L12 7.4l-1.6-1.6c-2-2-5.2-2-7.2 0-2 2-2 5.2 0 7.2L12 21l8.8-8c2-2 2-5.2 0-7.2Z"/>
      </svg>
    `,

    career: `
      <svg viewBox="0 0 24 24">
        <rect x="3" y="7" width="18" height="13" rx="2"/>
        <path d="M9 7V5h6v2"/>
        <path d="M3 12h18"/>
      </svg>
    `,

    star: `
      <svg viewBox="0 0 24 24">
        <path d="m12 3 2.8 5.7 6.2.9-4.5 4.4 1.1 6.2L12 17.3l-5.6 2.9 1.1-6.2L3 9.6l6.2-.9L12 3Z"/>
      </svg>
    `,

    sparkle: `
      <svg viewBox="0 0 24 24">
        <path d="M12 3c.8 4.3 3.2 6.7 7.5 7.5C15.2 11.3 12.8 13.7 12 18c-.8-4.3-3.2-6.7-7.5-7.5C8.8 9.7 11.2 7.3 12 3Z"/>
        <path d="M19 16c.3 1.7 1.3 2.7 3 3-1.7.3-2.7 1.3-3 3-.3-1.7-1.3-2.7-3-3 1.7-.3 2.7-1.3 3-3Z"/>
      </svg>
    `,

    user: `
      <svg viewBox="0 0 24 24">
        <circle cx="12" cy="8" r="4"/>
        <path d="M4 21a8 8 0 0 1 16 0"/>
      </svg>
    `,

    grid: `
      <svg viewBox="0 0 24 24">
        <rect x="4" y="4" width="6" height="6" rx="1"/>
        <rect x="14" y="4" width="6" height="6" rx="1"/>
        <rect x="4" y="14" width="6" height="6" rx="1"/>
        <rect x="14" y="14" width="6" height="6" rx="1"/>
      </svg>
    `
  };


  function getIconType(label) {

    const text =
      label
        .toLowerCase()
        .trim();


    if (text.includes('home')) {
      return 'home';
    }

    if (
      text.includes('product') ||
      text.includes('shop') ||
      text.includes('category') ||
      text.includes('collection')
    ) {
      return 'shop';
    }

    if (
      text.includes('offer') ||
      text.includes('bundle') ||
      text.includes('sale') ||
      text.includes('discount')
    ) {
      return 'offer';
    }

    if (
      text.includes('policy') ||
      text.includes('shipping') ||
      text.includes('refund') ||
      text.includes('privacy') ||
      text.includes('terms')
    ) {
      return 'shield';
    }

    if (text.includes('about')) {
      return 'info';
    }

    if (
      text.includes('contact') ||
      text.includes('support')
    ) {
      return 'contact';
    }

    if (
      text.includes('international') ||
      text.includes('global')
    ) {
      return 'globe';
    }

    if (
      text.includes('blog') ||
      text.includes('news')
    ) {
      return 'blog';
    }

    if (
      text.includes('wellness') ||
      text.includes('health')
    ) {
      return 'heart';
    }

    if (
      text.includes('career') ||
      text.includes('job')
    ) {
      return 'career';
    }

    if (
      text.includes('best seller') ||
      text.includes('popular')
    ) {
      return 'star';
    }

    if (
      text.includes('new arrival') ||
      text === 'new'
    ) {
      return 'sparkle';
    }

    if (
      text.includes('men') ||
      text.includes('women') ||
      text.includes('kids') ||
      text.includes('children')
    ) {
      return 'user';
    }

    return 'grid';
  }



  /* =======================================================
     CREATE A CLEAN LABEL SPAN
     Fixes underline on links WITH arrows/carets too
     ======================================================= */

  function prepareDesktopLabels(root) {

    root
      .querySelectorAll(
        '.header__inline-menu .header__menu-item'
      )
      .forEach(item => {

        let label =
          item.querySelector(
            ':scope > span'
          );


        if (label) {

          label.classList.add(
            'synmac-menu-label'
          );

          return;
        }


        const textNode =
          [...item.childNodes]
            .find(node =>
              node.nodeType === 3 &&
              node.textContent.trim()
            );


        if (!textNode) {
          return;
        }


        label =
          document.createElement('span');

        label.className =
          'synmac-menu-label';

        label.textContent =
          textNode.textContent.trim();


        item.insertBefore(
          label,
          textNode
        );


        textNode.remove();

      });

  }



  /* =======================================================
     MOBILE MENU ICONS
     ======================================================= */

  function prepareMobileIcons(root) {

    root
      .querySelectorAll(
        '.menu-drawer .menu-drawer__menu-item'
      )
      .forEach(item => {

        if (
          item.querySelector(
            ':scope > .synmac-menu-icon'
          )
        ) {
          return;
        }


        const label =
          item.textContent
            .replace(/\s+/g, ' ')
            .trim();


        if (!label) {
          return;
        }


        const type =
          getIconType(label);


        const icon =
          document.createElement('span');


        icon.className =
          'synmac-menu-icon';


        icon.setAttribute(
          'aria-hidden',
          'true'
        );


        icon.innerHTML =
          icons[type] ||
          icons.grid;


        item.prepend(icon);

      });

  }



  /* =======================================================
     DESKTOP AUTO-HOVER DROPDOWNS
     Parent + nested submenus
     ======================================================= */

  function prepareDesktopHover(root) {

    const hoverDesktop =
      window.matchMedia(
        '(min-width: 990px) and (hover: hover)'
      );


    if (!hoverDesktop.matches) {
      return;
    }


    root
      .querySelectorAll(
        '.header__inline-menu details'
      )
      .forEach(details => {

        if (
          details.dataset.synmacHoverReady
          === 'true'
        ) {
          return;
        }


        details.dataset.synmacHoverReady =
          'true';


        let closeTimer;


        const openMenu = () => {

          window.clearTimeout(
            closeTimer
          );

          details.open = true;

        };


        const closeMenu = () => {

          window.clearTimeout(
            closeTimer
          );


          closeTimer =
            window.setTimeout(
              () => {

                details.open = false;

              },
              100
            );

        };


        details.addEventListener(
          'mouseenter',
          openMenu
        );


        details.addEventListener(
          'mouseleave',
          closeMenu
        );


        details.addEventListener(
          'focusin',
          openMenu
        );


        details.addEventListener(
          'focusout',
          event => {

            if (
              !details.contains(
                event.relatedTarget
              )
            ) {
              closeMenu();
            }

          }
        );

      });

  }



  function initialise(root = document) {

    prepareDesktopLabels(root);

    prepareMobileIcons(root);

    prepareDesktopHover(root);

  }



  document.addEventListener(
    'DOMContentLoaded',
    () => initialise(document)
  );


  document.addEventListener(
    'shopify:section:load',
    event => initialise(event.target)
  );

})();
/* =========================================================
   SYNMAC MOBILE INLINE SUBMENUS — FINAL PATCH
   Prevent Dawn from opening child menu as separate page
   ========================================================= */

(() => {

  function setupSynmacInlineMenus(scope = document) {

    scope
      .querySelectorAll(
        '.menu-drawer details > summary.menu-drawer__menu-item'
      )
      .forEach(summary => {

        if (
          summary.dataset.synmacInlineReady === 'true'
        ) {
          return;
        }


        summary.dataset.synmacInlineReady =
          'true';


        /*
         Capture phase intentionally used:
         it stops Refresh/Dawn's side-panel JS,
         but DOES NOT prevent native <details> opening.
        */

        summary.addEventListener(
          'click',
          event => {

            if (
              !window.matchMedia(
                '(max-width: 989px)'
              ).matches
            ) {
              return;
            }


            event.stopImmediatePropagation();


            const details =
              summary.closest('details');


            if (!details) {
              return;
            }


            /*
             Native details toggles after click.
             Then update accessibility state.
            */

            requestAnimationFrame(() => {

              summary.setAttribute(
                'aria-expanded',
                details.open
                  ? 'true'
                  : 'false'
              );

            });

          },
          true
        );

      });

  }


  document.addEventListener(
    'DOMContentLoaded',
    () => {

      setupSynmacInlineMenus();

    }
  );


  document.addEventListener(
    'shopify:section:load',
    event => {

      setupSynmacInlineMenus(
        event.target
      );

    }
  );

})();